

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import moment from "moment";
    import Utils from "@/utilities/Utils";

    @Component({ })
    export default class DatePicker extends Vue {

        mounted(): void {
            // rewire the rules so they operate on the DATE value and NOT the contents of the text field!

            // TODO - not too sure this actually works :-S
            // (see SouthEastern.vue)

            this.dateRules = this.rules.map(r => {
                return (v?: any) => r(this.lastPickerValue);
            });
        }

        @Prop({ default: () => { return new Date() } })
        pickerDefault!: Date;

        @Prop({ default: null })
        value!: Date;

        @Prop({ required: true })
        label!: string;

        @Prop({ default: () => [] })
        rules!: Array<(() => string | boolean) | ((v: any) => string | true)>

        dateRules: Array<(() => string | boolean) | ((v: any) => string | true)> = [];

        isPickerVisible: boolean = false;
        lastPickerValue: Date|null = null;

        // get dateValue(): string|null {
        //     const m = moment(this.value);
        //     return m.isValid() ? m.format("YYYY-MM-DD") : null;
        // }

        get pickerTextValue(): string | undefined {
            let m = moment(this.value);
            if(!m.isValid() || m.year() < 1600) {
                const d = moment(this.pickerDefault);
                return d.isValid() ? d.format("YYYY-MM-DD") : "2000-01-01";
            }
            return m.format("YYYY-MM-DD");
        }

        get textFieldValue (): string|null {
            return Utils.dateText(this.value, "");
        }

        onTextFieldInput(value: string|null) {
            // it's readonly - but this will fire when we *clear* the field!
            if(!value) {
                this.$emit('input', null);
            }
        }

        onPickerInput(value: string|null) {
            const m = moment(value);
            // keep the value around for validation
            this.lastPickerValue = m.isValid() ? m.toDate() : null;
            this.$emit("input", this.lastPickerValue);
            this.isPickerVisible = false;
        }

        selectToday() {
            this.$emit('input', new Date());
            this.isPickerVisible = false;
        }
    }
